import React from 'react';
interface AvatarProps {
  src: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  bordered?: boolean;
  status?: 'online' | 'offline' | 'none';
  sport?: string;
}
const Avatar = ({
  src,
  size = 'md',
  bordered = false,
  status = 'none',
  sport
}: AvatarProps) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };
  const sportBgColors: Record<string, string> = {
    football: 'bg-green-100 text-green-700',
    basketball: 'bg-orange-100 text-orange-700',
    baseball: 'bg-blue-100 text-blue-700',
    tennis: 'bg-yellow-100 text-yellow-700',
    golf: 'bg-emerald-100 text-emerald-700',
    default: 'bg-gray-100 text-gray-700'
  };
  const bgColorClass = sport ? sportBgColors[sport] || sportBgColors.default : sportBgColors.default;
  return <div className="relative" data-id="element-580">
      <div className={`
        ${sizeClasses[size]} 
        rounded-full overflow-hidden
        ${bordered ? 'ring-2 ring-green-500 ring-offset-2' : ''}
      `} data-id="element-581">
        <img src={src} alt="User avatar" className="w-full h-full object-cover rounded-full" data-id="element-582" />
        {sport && <div className="absolute -bottom-1 -right-1 bg-white rounded-full p-0.5 shadow-sm" data-id="element-583">
            <div className={`text-xs ${bgColorClass} rounded-full w-5 h-5 flex items-center justify-center font-medium`} data-id="element-584">
              {sport.charAt(0).toUpperCase()}
            </div>
          </div>}
      </div>
      {status !== 'none' && <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white
          ${status === 'online' ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-585" />}
    </div>;
};
export default Avatar;